import { T_CONTACT_US_FORM_PAGE_CONSTANTS } from './TYPES'

const FR_CONTACT_US_FORM_PAGE_CONSTANTS: T_CONTACT_US_FORM_PAGE_CONSTANTS = {
  FULL_NAME_LABEL: 'Nom complet',
  FULL_NAME_PLACEHOLDER: 'Entrez votre nom complet',
  FULL_NAME_ERRORS_REQUIRED: 'Le nom complet est requis.',
  EMAIL_ID_LABEL: 'Adresse e-mail',
  EMAIL_ID_PLACEHOLDER: 'Entrez votre adresse e-mail',
  EMAIL_ID_ERRORS_REQUIRED: "L'adresse e-mail est requise.",
  EMAIL_ID_ERRORS_INVALID: 'Entrez une adresse e-mail valide.',
  SUBJECT_LABEL: 'Sujet',
  SUBJECT_PLACEHOLDER: 'Entrez un sujet',
  SUBJECT_ERRORS_REQUIRED: 'Le sujet est requis.',
  MESSAGE_LABEL: 'Votre message',
  MESSAGE_PLACEHOLDER: 'Entrez votre message',
  MESSAGE_ERRORS_REQUIRED: 'Le message est requis.',
  SEND_CTA_TEXT: 'Envoyer'
}

export default FR_CONTACT_US_FORM_PAGE_CONSTANTS
